<footer class="main-footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                <h4 [ngClass]="{ 'text-end' : lang == 'ar' }">{{"call us" | translate}}</h4>
                <ul class="list-unstyled text-right">
                    
                    <li (click)="call();" class="align-items-center d-flex gap-2">
                        <i class="fas fa-mobile-alt text-white"></i>
                        002-01141087755
                    </li>
                    
                    <li (click)="whatsapp_chat();" class="align-items-center d-flex gap-2">
                        <i class="fab fa-whatsapp text-white"></i>
                        002-01141087755
                    </li>
                    
                    <li class="d-flex flex-column flex-lg-row gap-0 gap-lg-4">
                    
                        <!-- <div (click)="email();" class="align-items-center d-flex gap-2">
                            <i class="far fa-envelope text-white"></i>
                            hossamxp33@gmail.com                
                        </div>

                        <div class="sepeate-mail" class="d-lg-block d-none sepeate-mail"></div> -->
                        
                        <div (click)="email_2();" class="align-items-center d-flex mt-1 mt-lg-0 gap-2">
                            <i class="far fa-envelope text-white"></i>
                            info@CodesRoots.com 
                        </div>
                    
                    </li>          
         
                </ul>
            </div>
            <div class="col-md-6">
                <h3 class="text-center">CodesRoots</h3>
                <h4 class="text-center">{{"Integrated web services" | translate}}</h4>
                
                <div class="create-ticket-btn mx-auto overflow-hidden position-relative" style="width: 150px;">
                    <a routerLink="/تواصل-معنا" matRipple class="fs-6 overflow-hidden mx-0 text-black">
                        {{"create ticket" | translate}}
                    </a>
                </div>

            </div>            
        </div>
    </div>
</footer>